// VENDORED COPY of frontend/src/lib/financial/date-utils.ts — do not edit here; keep in sync with the main app.
/**
 * Date utility functions for financial horizon calculations.
 *
 * Ported from static/apps/lib/financial-calc.js to eliminate the
 * window.AppLib dependency. Logic is an exact mirror of the legacy
 * parseDate, getMonthDiff, and getDefaultStartDate functions.
 */

/**
 * Parse a date string or Date object into a Date instance.
 * Returns a new Date() if the input is neither a string nor a Date.
 *
 * @param date - ISO date string or Date object
 * @returns Parsed Date
 */
export function parseDate(date: string | Date | null | undefined): Date {
  if (date instanceof Date) return date;
  if (typeof date === 'string') return new Date(date);
  return new Date();
}

/**
 * Calculate the month-index difference between two dates.
 * Result can be negative if targetDate is before startDate.
 *
 * @param startDate - Reference start date
 * @param targetDate - Target date to measure against
 * @returns Number of months from start to target
 */
export function getMonthDiff(startDate: Date, targetDate: Date): number {
  return (
    (targetDate.getFullYear() - startDate.getFullYear()) * 12 +
    (targetDate.getMonth() - startDate.getMonth())
  );
}

/**
 * Get the default horizon start date: first day of the current month.
 *
 * @returns Date set to the 1st of the current month at midnight
 */
export function getDefaultStartDate(): Date {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), 1);
}
